export default [
  { code: 200, message: 'SUCCESS' },
  { code: 400, message: 'VALIDATE_FAILED' },
  { code: 401, message: 'UNAUTHORIZED' },
  { code: 411, message: 'INVALID_PASSWORD' },
  { code: 421, message: 'UNAVAILABLE' },
  { code: 403, message: 'FORBIDDEN' },
  { code: 404, message: 'POSTCODE_NOT_EXIST' },
  { code: 405, message: 'NOT_REGISTERED' },
  { code: 406, message: 'VERIFICATION_CODE_ERROR' },
  { code: 416, message: 'VERIFICATION_CODE_EXPIRE' },
  { code: 407, message: 'USER_NOT_EXIST' },
  { code: 417, message: 'CRM_ACCOUNT_NOT_EXIST' },
  { code: 408, message: 'USER_EXIST' },
  { code: 409, message: 'CONFIRM_PASSWORD' },
  { code: 410, message: 'FILE_UPLOAD_KEY_GET_FAIL' },
  { code: 499, message: 'MODEL_NOT_BELONG' },
  { code: 500, message: 'FAILED' },
  { code: 501, message: 'REQUEST_FREQUENTLY' },
  { code: 601, message: 'FILE_SHARE_ERROR_DEL' },
  { code: 602, message: 'FILE_SHARE_ERROR_UNAUTHORIZED' },
  { code: 603, message: 'FILE_SHARE_ERROR_EMAIL_NOT_EXISTS' },
  { code: 604, message: 'FILE_SHARE_ERROR_UNKNOWN' },
  { code: 605, message: 'FILE_SHARE_ERROR_REPEAT_SHARING' },
  { code: 606, message: 'FILE_SHARE_ERROR_SELF' },
  { code: 607, message: 'FILE_SHARE_UPDATE_FAIL' },
  { code: 608, message: 'FILE_DOWNLOAD_ERROR_DEL' },
  { code: 609, message: 'FILE_SHARE_DEL_FAIL' },
  { code: 610, message: 'FILE_SHARE_DEL_FAIL_NO_AUTHORITY' },
  { code: 611, message: 'CREDIT_CARD_PAY_ERROR' },
  { code: 612, message: 'CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY' },
  { code: 613, message: 'PERMITS_CONVERT_FAIL' },
  { code: 614, message: 'PERMITS_CONVERT_FAIL_USER_NULL' },
  { code: 615, message: 'APP_TRANSLATION_INVALID' },
  { code: 616, message: 'APP_TRANSLATION_HISTORY_GET_FAIL' },
  { code: 617, message: 'APP_TRANSLATION_STATUS_GET_FAIL' },
  { code: 618, message: 'FILE_UPLOAD_FILE_PATH_EMP_ERROR' },
  { code: 619, message: 'FILE_UPLOAD_FILE_DB_FAIL_ERROR' },
  { code: 701, message: 'APP_TOKEN_GET_FAIL' },
  { code: 702, message: 'APP_IP_ADDRESS_NOT_ALLOW' },
  { code: 703, message: 'CONTACT_ALREADY_EXIST' },
  { code: 704, message: 'ACCOUNT_PLAN_NOT_EXIST' },
  { code: 705, message: 'ACCOUNT_PLAN_TYPE_ERROR' },
  { code: 706, message: 'ACCOUNT_PLAN_DOWNGRADE' },
  { code: 707, message: 'ACCOUNT_PLAN_PREPAY_MONTH_ERROR' },
  { code: 708, message: 'ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER' },
  { code: 709, message: 'CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST' },
  { code: 710, message: 'FINCODE_PLAN_ID_NOT_EXIST' },
  { code: 711, message: 'CUSTOMER_NAME_DUPLICATE' },
  { code: 712, message: 'CUSTOMER_NAME_BLANK_NOT_ALLOW' },
  { code: 713, message: 'ACCOUNT_NOT_EXIST' },
  { code: 714, message: 'CUSTOMER_NOT_EXIST' },
  { code: 715, message: 'FINCODE_CARD_ID_BLANK_NOT_ALLOW' },
  { code: 716, message: 'CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN' },
  { code: 717, message: 'CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT' },
  { code: 718, message: 'ACCOUNT_IN_USE_HAS_REACHED_MAX' },
  { code: 719, message: 'ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX' },
  { code: 720, message: 'ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES' },
  { code: 721, message: 'ACCOUNT_EMAIL_ALREADY_EXISTS' },
  { code: 722, message: 'ACCOUNT_LIST_CANNOT_BE_EMPTY' },
  { code: 723, message: 'FREEE_TOKEN_GET_ERROR' },
  { code: 724, message: 'FREEE_API_REQUEST_ERROR' },
  { code: 725, message: 'FREEE_INVOICE_LIST_ERROR' },
  { code: 726, message: 'FREEE_INVOICE_DETAIL_ERROR' },
  { code: 728, message: 'FREEE_ADD_INVOICE_ERROR' },
  { code: 729, message: 'FREEE_ADD_PARTNER_ERROR' },
  { code: 730, message: 'FREEE_UPDATE_PARTNER_ERROR' },
  { code: 731, message: 'FREEE_PARTNER_DETAIL_ERROR' },
  { code: 732, message: 'FREEE_PARTNER_LIST_ERROR' },
  { code: 733, message: 'ACCOUNT_PLAN_ORDER_NOT_EXISTS' },
  { code: 734, message: 'CUSTOMER_ALREADY_ADDED' },
  { code: 735, message: 'ORDER_NOT_EXIST' },
  { code: 736, message: 'ORDER_STATUS_ERROR' },
  { code: 737, message: 'ORDER_PAYMENT_METHOD_NOT_ALLOW' },
  { code: 738, message: 'FINCODE_CUSTOMER_CARD_NOT_FOUND' },
  { code: 739, message: 'FREEE_PARTNER_NOT_FOUND' },
  { code: 740, message: 'CUSTOMER_ALREADY_BOUND_PLAN' },
  { code: 741, message: 'MY_USER_PHONE_NUMBER_ALREADY_EXISTS' },
  { code: 742, message: 'MY_USER_EMAIL_ALREADY_EXISTS' },
  { code: 743, message: 'ROLE_NAME_DUPLICATE' },
  { code: 744, message: 'THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED' },
  { code: 745, message: 'THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT' },
  { code: 746, message: 'THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED' },
  { code: 747, message: 'ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS' },
  { code: 748, message: 'AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION' },
  { code: 749, message: 'MOST_FIVE_DEPT_LEVELS' },
  { code: 750, message: 'DEPT_NAME_ALREADY_EXISTS' },
  { code: 751, message: 'THE_DEPT_HAS_SUB_DEPT' },
  { code: 752, message: 'THERE_ARE_USERS_IN_THIS_DEPT' },
  { code: 753, message: 'THERE_ARE_ROLES_BOUND_TO_THIS_DEPT' },
  { code: 754, message: 'THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT' },
  { code: 755, message: 'CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD' },
  { code: 756, message: 'THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS' },
  { code: 759, message: 'CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE' },
  { code: 760, message: 'THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT' },
  { code: 761, message: 'THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT' },
  { code: 762, message: 'THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED' },
  { code: 763, message: 'THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER' },
  { code: 764, message: 'THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER' },
  { code: 765, message: 'THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT' },
  { code: 766, message: 'THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT' },
  { code: 767, message: 'THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT' },
  { code: 768, message: 'THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST' },
  { code: 769, message: 'CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES' },
  { code: 770, message: 'CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE' },
  { code: 771, message: 'CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE' },
  { code: 772, message: 'THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED' },
  { code: 773, message: 'THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE' },
  { code: 774, message: 'CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED' },
  { code: 775, message: 'THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED' },
  { code: 776, message: 'ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS' },
  { code: 777, message: 'ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS' },
  { code: 778, message: 'UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS' },
  { code: 779, message: 'THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT' },
  { code: 780, message: 'THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT' },
  { code: 781, message: 'CUSTOMER_INFO_NOT_ADDED' },
  { code: 782, message: 'FREEE_PARTNER_NOT_EXIST' },
  { code: 783, message: 'INVITATION_NOT_EXIST' },
  { code: 784, message: 'INVITATION_STATUS_ERROR' },
  { code: 785, message: 'INVITATION_STATUS_INVALID' },
  { code: 786, message: 'INVITATION_STATUS_EXPIRED' },
  { code: 787, message: 'INVITATION_CHECK_CODE_WRONG' },
  { code: 788, message: 'CUSTOMER_ACCOUNT_PLAN_IN_EFFECT' },
  { code: 789, message: 'CUSTOMER_NOT_ALLOW_CHANGE' },
  { code: 790, message: 'ACCOUNT_EMAIL_OVER_LENGTH' },
  { code: 791, message: 'USER_STATUS_UNAVAILABLE' },
  { code: 792, message: 'USER_STATUS_AVAILABLE' },
  { code: 793, message: 'USER_STATUS_ACCOUNT_EXPIRED' },
  { code: 794, message: 'USER_STATUS_LOGOUT' },
  { code: 795, message: 'USER_STATUS_ACTIVE' },
  { code: 796, message: 'USER_STATUS_TO_BE_EFFECTIVE' },
  { code: 797, message: 'USER_STATUS_DEACTIVATE' },
  { code: 798, message: 'USER_STATUS_PRE_DEACTIVATE' },
  { code: 799, message: 'USER_STATUS_PRE_ABNORMALITY' },
  { code: 800, message: 'AGENT_NOT_EXIST' },
  { code: 801, message: 'AGENT_NAME_DUPLICATE' },
  { code: 802, message: 'REQUEST_BOOK_NOT_EXIST' },
  { code: 803, message: 'FILE_CREATE_FAIL' },
  { code: 804, message: 'SALES_DATE_EMPTY' },
  { code: 805, message: 'EXTEND_PLAN_CONFIG_ERROR' },
  { code: 806, message: 'CAN_NOT_FIND_WEB_MODEL_KEY' },
  { code: 807, message: 'CAN_NOT_FIND_WEB_MODEL_FOLDER' },
  { code: 808, message: 'FOLDER_CANT_MOVE_INTO_SUB_FOLDER' },
  { code: 808, message: 'FOLDER_CONTAIN_SUB_FOLDER' },
  { code: 809, message: 'WEB_MODEL_ALREADY_IN_FOLDER' },
  { code: 810, message: 'FOLDER_NAME_SAME' },
  { code: 811, message: 'MODEL_OUTLINE_NOT_EXIST' },
  { code: 812, message: 'WEB_MODEL_NO_AUTH' },
  { code: 814, message: 'SEAT_NUM_TOO_SMALL' },
  { code: 815, message: 'SEAT_NUM_TOO_BIG' },
  { code: 816, message: 'SEAT_NUM_LESS_THAN_USED' },
  { code: 819, message: 'CUSTOMER_PLAN_NOT_CANCELED' },
  { code: 820, message: 'CUSTOMER_PLAN_EXIST' },
  { code: 821, message: 'CUSTOMER_PLAN_ALREADY_CANCELED' },
  { code: 824, message: 'CUSTOMER_PLAN_NOT_A' },
  { code: 826, message: 'CUSTOMER_PLAN_PERIOD_ERROR' },
  { code: 827, message: 'START_TIME_ILLEGAL' },
  { code: 828, message: 'STRIPE_ONE_TIME_PRICE_NOT_FOUND' },
  { code: 829, message: 'CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM' },
  { code: 830, message: 'ORDER_NOT_BELONG' },
  { code: 831, message: 'WEB_PERMISSION_NOT_ALLOW_INACTIVE' },
  { code: 832, message: 'CUSTOMER_HAS_ACCOUNT_IN_USE' },
  { code: 833, message: 'CAD_PLAN_GOODS_NOT_EXIST' },
  { code: 834, message: 'CAD_ORDER_NOT_EXIST' },
  { code: 835, message: 'CAD_ORDER_STATUS_ERROR' },
  { code: 836, message: 'CAD_ORDER_FILE_TOO_MANY' },
  { code: 837, message: 'ACCOUNT_PLAN_PERIOD_NOT_ALLOW' },
  { code: 839, message: 'CUSTOMER_PLAN_END_TIME_BEFORE_NOW' },
  { code: 840, message: 'EXPAND_SEAT_NOT_ZERO' },
  { code: 841, message: 'EXPAND_A_NOT_ALLOW' },
  { code: 842, message: 'ACCOUNT_PLAN_GOODS_NOT_EXIST' },
  { code: 843, message: 'CAD_PLAN_GOODS_IS_USED' },
  { code: 844, message: 'DOMAIN_ALREADY_EXIST' },
  { code: 845, message: 'LOCATION_WITH_SNAPSHOT' },
  { code: 846, message: 'LOCATION_NOT_FOUNT' },
  { code: 847, message: 'FLOOR_NOT_EXIST' },
  { code: 848, message: 'AUTO_ALIGN_FAIL' },
  { code: 849, message: 'CAN_NOT_CHANGE_MEMBER_ROLE' },
  { code: 850, message: 'CAN_NOT_USE_SEAT' },
  { code: 851, message: 'APPLICATION_NOT_EXIST' },
  { code: 852, message: 'PROCESSING_RESULT_NOT_EXIST' },
  { code: 853, message: 'PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST' },
  { code: 854, message: 'PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL' },
  { code: 855, message: 'PLAN_CANCEL_APPLICATION_EMAIL_ERROR' },
  { code: 856, message: 'PLAN_CANCEL_APPLICATION_EXIST' },
  { code: 857, message: 'ACCOUNT_CAN_NOT_USE' },
  { code: 858, message: 'ACCOUNT_NOT_BUY_PLAN' },
  { code: 859, message: 'CUSTOMER_NOT_BUY_PLAN' },
  { code: 860, message: 'ACCOUNT_PLAN_EXPIRED' },
  { code: 861, message: 'CUSTOMER_PLAN_EXPIRED' },
  { code: 862, message: 'ACCOUNT_PLAN_TOBE_EFFECTIVE' },
  { code: 863, message: 'ACCOUNT_NO_SEAT' },
  { code: 864, message: 'CAN_NOT_EDIT_MEMBER' },
  { code: 865, message: 'ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER' },
  { code: 866, message: 'COOPERATOR_PERMISSION_DENIED' },
  { code: 867, message: 'TEAM_SPACE_FOLDER_CREATE_NO_ADMIN' },
  { code: 868, message: 'NOT_A_FOLDER' },
  { code: 869, message: 'FOLDER_SPACE_MISMATCH' },
  { code: 870, message: 'FOLDER_DEPTH_EXCEEDED' },
  { code: 871, message: 'SPACE_FOLDER_CONTAIN_SUB_FOLDER' },
  { code: 872, message: 'SPACE_FILE_ALREADY_IN_FOLDER' },
  { code: 873, message: 'CAN_NOT_FIND_SPACE_FILE' },
  { code: 874, message: 'SPACE_FILE_PATH_NULL' },
  { code: 875, message: 'COOPERATOR_ALREADY_EXISTS' },
  { code: 876, message: 'INVITE_KEY_NOT_EXIST' },
  { code: 877, message: 'INVITE_EMAIL_ERROR' },
  { code: 878, message: 'INVITE_STATUS_ERROR' },
  { code: 879, message: 'INVITE_STATUS_EXPIRED' },
  { code: 880, message: 'INVITE_CUSTOMER_PLAN_NOT_EXIST' },
  { code: 900, message: 'NOT_HAS_WEB_PERMISSION' },
  { code: 901, message: 'MODEL_IS_NOT_EXIST' },
  { code: 902, message: 'SHARE_LINK_NOT_EXIST' },
  { code: 903, message: 'NOT_CUSTOMER_MEMBER' },
  { code: 904, message: 'SHARE_LINK_PASSWORD_ERROR' },
  { code: 905, message: 'STRIPE_PAYMENT_METHOD_NOT_ALLOW' },
  { code: 20000, message: 'EMAIL_CODE_REQUIRED' },
  { code: 20001, message: 'NOT_ADMIN_FORBIDDEN' },
  { code: 20002, message: 'NOT_ACTIVE_FORBIDDEN' },
  { code: 20003, message: 'PAYMENT_REQUIRE_ACTION' }
]
